import React, { FC } from 'react';
import { Calendar } from 'react-feather';

type DateRangeProps = {
  start: string | null; // 'YYYY-MM-DD'
  end: string | null; // 'YYYY-MM-DD'
};

const isValidDateString = (value: string | null) =>
  !!value && value !== '0000-00-00' && !Number.isNaN(new Date(value).getTime());

const DateRange: FC<DateRangeProps> = ({ start, end }) => {
  if (!isValidDateString(start) || !isValidDateString(end)) {
    return null;
  }

  const startDate = new Date(start);
  const endDate = new Date(end);

  const monthFormatter = new Intl.DateTimeFormat('nl-BE', {
    month: 'short',
  });

  const dayFormatter = new Intl.DateTimeFormat('nl-BE', {
    day: 'numeric',
  });

  const format = (date: Date) =>
    `${monthFormatter.format(date)} ${dayFormatter.format(date)}`;

  let label: string;

  // Same day
  if (startDate.toDateString() === endDate.toDateString()) {
    label = format(startDate);
  }
  // Same month
  else if (
    startDate.getFullYear() === endDate.getFullYear() &&
    startDate.getMonth() === endDate.getMonth()
  ) {
    label = `${monthFormatter.format(startDate)} ${dayFormatter.format(
      startDate
    )} - ${dayFormatter.format(endDate)}`;
  }
  // Different months
  else {
    label = `${format(startDate)} - ${format(endDate)}`;
  }

  return (
    <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-gray-300 dark:border-slate-700 rounded-full text-sm text-gray-700 dark:text-gray-200">
      <Calendar size={14} className="text-gray-500 dark:text-gray-400" />
      <span>{label}</span>
    </div>
  );
};

export default DateRange;
